import ThankYouView from './ThankYouView';

export default ThankYouView;
